import { spanSize, spanType, spanStyle  } from './theme.js';

export default function span({size, type, style, children}){
	const classNames = spanSize[size] + " " + spanType[type];
	const styleType = spanStyle[style];
	return(
		<span className={classNames} style={styleType}>{children}</span>
	)
}
